import { COLORS } from '../../../../config/designSystem/Colors';
import { Caption2Reg } from '../../../../config/designSystem/typography';
import { CircleButton } from '../CirculButton';
import { FC } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { observer } from 'mobx-react';

interface SingleSelectProps {
  label: string;
  onPress: () => void;
  selected: boolean;
}

const _PresentFeedbackProgram: FC<SingleSelectProps> = ({
  label,
  onPress,
  selected
}) => {


  const EDGE_WIDTH = 20;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{ flexDirection: 'row',
        columnGap: 12,
        alignItems: 'center'}}
    >
      <View style={{ width: EDGE_WIDTH}}>
        <CircleButton selected={selected} edge={EDGE_WIDTH} colorUnselected={COLORS.border.primary}/>
      </View>
      <Caption2Reg
        selectable={false}
        color={COLORS.content.primary}
      >
        {label}
      </Caption2Reg>

    </TouchableOpacity>

  );
};




export const PresentFeedbackProgram = observer(_PresentFeedbackProgram);
